import { useApplicationStore } from '@data';
import { ContextHeading, Paragraph } from '@quickmd-llc/design-system';

type Props = { isOrderConfirmation?: boolean };

export function RefillOrderSummary({ isOrderConfirmation = false }: Props) {
  const activeRefill = useApplicationStore(
    ({ patient }) => patient.activeRefill,
  );

  if (!activeRefill) {
    return null;
  }

  const { durationDisplay, name, remainingRefillQuantity } = activeRefill;

  const refillsRemainingText = getRefillsRemainingText(
    remainingRefillQuantity,
    isOrderConfirmation,
  );

  return (
    <>
      <Paragraph className="mb-2 font-semibold text-shade-95">
        Order Summary
      </Paragraph>

      <div className="flex items-center gap-3 rounded-lg border border-shade-10 bg-white p-4">
        <img
          className="h-20 w-20 animate-pulse rounded-lg bg-gray-100"
          src="/images/refill-order-summary.png"
          alt="Refill medication"
          onLoad={({ currentTarget }) => {
            currentTarget.classList.remove('animate-pulse');
            currentTarget.classList.remove('bg-gray-100');
          }}
        />

        <div>
          <ContextHeading>{name}</ContextHeading>

          <div>
            <Paragraph
              size="sm"
              className="break-normal text-shade-70 first-letter:uppercase"
            >
              {durationDisplay}
            </Paragraph>

            <Paragraph size="sm" className="break-normal text-shade-70">
              {refillsRemainingText}
            </Paragraph>
          </div>
        </div>
      </div>
    </>
  );
}

function getRefillsRemainingText(
  remainingRefillQuantity: number,
  isOrderConfirmation: boolean,
) {
  const quantity = isOrderConfirmation
    ? remainingRefillQuantity - 1
    : remainingRefillQuantity;

  return `${quantity} refill${quantity === 1 ? '' : 's'} remaining`;
}
